import React, { useEffect, useState } from "react";
import * as moment from "moment-timezone";
import { formatPrice } from "../../eventDetails/seats";
import { SeatsioSeatingChart } from "@seatsio/seatsio-react";



const ChooseSeats = (props) => {
    const {
        eventDetails,
        eventPageProduct,
        mobileView,
        updateQuantity,
        setFullScreen,
        selectedDateGid
    } = props;

    let productCopy = eventPageProduct;
    const [publicKey, setPublicKey] = useState();
    const [eventKey, setEventKey] = useState();
    const [seatInfo, setSeatInfo] = useState();
    const [tooltipData, setTooltipData] = useState();
    const [count, setCount] = useState(0);
    const [timer, setTimer] = useState(true);

    useEffect(() => {
        if (!timer) {
            setTimeout(() => {
                const newCount = count - 1;
                setCount(newCount >= 0 ? newCount : 0);
                if (newCount <= 0) {
                    // chartRef.current.clearSelection();
                    // expiredToken();
                }
            }, 1000);
        }
    }, [count]);

    useEffect(() => {
        // Access seat data based on selectedDateGid
        const selectedDateTime = eventDetails?.eventPageDateTimes?.find(dt => dt.gid === selectedDateGid) || eventDetails?.eventPageDateTimes?.[0];

        if (selectedDateTime?.seatData && productCopy.eventPageProductType === 'TICKET') {
            const encodeQuery = atob(selectedDateTime.seatData);
            const parseData = JSON.parse(encodeQuery);
            const publicId = atob(selectedDateTime.seatPublicKey);
            const eventId = atob(selectedDateTime.seatEventId);

            console.log('Seat data loaded:', { publicId, eventId, pricingData: parseData.pricingData });

            setPublicKey(publicId);
            setEventKey(eventId);
            setSeatInfo(parseData.pricingData);
            setTooltipData(parseData.tooltipData);
            if (timer) {
                const seconds = 900;
                if (timer) {
                    setCount(Math.trunc(seconds));
                    setTimer(false);
                }
            }
        }
    }, [eventDetails, productCopy.eventPageProductType, selectedDateGid]);

    const tooltipFormat = (obj) => {
        if (!obj || !obj.category) return "";
        const keyId = obj.category.key;
        const tooltipLabel = tooltipData && tooltipData.filter((data) => data.category.id === keyId);
        if (tooltipLabel && tooltipLabel.length !== 0) {
            return "" + tooltipLabel[0].category.tooltip;
        }
        return "";
    };
    const onObjectSelected = async (item) => {
        if (!item) return;

        const selectedGid = item.selectedTicketType;
        const customItem = eventPageProduct?.customItems?.find((data) => data.gid === selectedGid);
        const regularItem = eventPageProduct?.items?.find((data) => data.gid === selectedGid);
        const price = item.selectedPricing ? item.selectedPricing.price : (customItem?.amount || regularItem?.price || 0);

        if (customItem || regularItem) {
            updateQuantity(customItem, regularItem, null, item.label, 1, price);
        }
    };

    const onObjectDeselected = async (item, price) => {
        if (!item) return;
        const selectedGid = price && price.ticketType;
        const customItem = eventPageProduct?.customItems?.find((data) => data.gid === selectedGid);
        const regularItem = eventPageProduct?.items?.find((data) => data.gid === selectedGid);
        const deselectPrice = price ? price.price : (customItem?.amount || regularItem?.price || 0);
        updateQuantity(customItem, regularItem, null, item.label, -1, deselectPrice);
    };

    const onFullScreenOpened = () => {
        setFullScreen(true);
    };

    const onFullScreenClosed = () => {
        setFullScreen(false);
    };

    console.log('Rendering ChooseSeats:', { publicKey, eventKey, seatInfo });

    return (
        <>
            {eventPageProduct && (
                <div
                    className="seats-container"
                    style={{
                        width: '100%',
                        minHeight: '600px',
                        background: '#f9f9f9', // Light background to see the container
                        padding: '20px'
                    }}
                >
                    {!publicKey || !eventKey || !seatInfo ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>Loading Seat Map...</div>
                    ) : (
                        <SeatsioSeatingChart
                            workspaceKey={publicKey}
                            pricing={seatInfo}
                            priceFormatter={(price) => formatPrice(price)}
                            event={eventKey}
                            showFullScreenButton
                            region="na"
                            onObjectSelected={onObjectSelected}
                            onObjectDeselected={(item, price) => onObjectDeselected(item, price)}
                            holdOnSelect={true}
                            holdToken={sessionStorage.getItem("seatsio") ? JSON.parse(sessionStorage.getItem("seatsio")).holdToken : undefined}
                            tooltipInfo={(object) => tooltipFormat(object)}
                            onFullScreenOpened={onFullScreenOpened}
                            onFullScreenClosed={onFullScreenClosed}
                            selectionValidators={[]}
                            multiSelect={true}
                            confirmSelectionOnMobile={false}
                            select={{
                                mode: 'multi',
                                autoSelectOneTicketType: true
                            }}
                            language="en"
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default ChooseSeats;
